<template>
  <div class="movable-panel" ref="movable" :class="movableClass" :style="movableStyle" @touchstart="onTouchStart">
    <div class="movable-menu" @click="$emit('on-click')">
      <slot>
        <div class="default-menu">
          <span class="movable-menu-icon iconfont" :class="iconClass" v-if="iconClass"></span>
          <span class="movable-menu-icon iconfont icon-common_icon_face_add" v-else></span>
          <div class="movable-menu-text">{{ text }}</div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
const PanelState = {
  LEFT: 0, // 贴靠屏幕左侧
  RIGHT: 1, // 贴靠屏幕右侧
  DRAGGING: 2, // 拖拽中
}

const PanelStateClass = {
  LEFT: 'left', // 贴靠屏幕左侧
  RIGHT: 'right', // 贴靠屏幕右侧
  DRAGGING: 'is-dragging', // 拖拽中
}

export default {
  name: "movable-panel",
  props: {
    boundary: {
      type: Number,
      default: 80
    },
    iconClass: String,
    text: {
      type: String,
      required: true
    },
    zIndex: {
      type: Number,
      default: 9999
    },
    position: {
      type: Object,
      default() {
        return {x: 'right', y: '67.5%'}
      },
    }
  },
  data() {
    return {
      panelStatus: this.position ? PanelState[this.position.x.toUpperCase()] : PanelState.RIGHT,
    }
  },
  computed: {
    movableClass() {
      let statusClass = {
        [PanelState.LEFT]: PanelStateClass.LEFT,
        [PanelState.RIGHT]: PanelStateClass.RIGHT,
        [PanelState.DRAGGING]: PanelStateClass.DRAGGING,
      }
      return statusClass[this.panelStatus];
    },
    movableStyle() {
      let styleObj = {zIndex: this.zIndex}
      if (this.position) {
        let top = this.position.y || 0;
        if (!isNaN(top)) {
          let topNumber = top / 750 * window.innerWidth;
          let elementHeight = this.$refs.movable ? this.$refs.movable.clientHeight : 100 / 750 * window.innerWidth
          let maxTop = window.innerHeight - this.boundary - elementHeight;

          if (topNumber < this.boundary){
            top = this.boundary + 'px'
          } else if (topNumber > maxTop) {
            top = maxTop + 'px'
          } else {
            top = topNumber + 'px'
          }
        }
        styleObj.top = top
      }
      return styleObj
    },
  },
  watch:{
    panelStatus:{
      handler(oldValue, newValue){
        if(oldValue !== newValue) {
          let statusClass = {
            [PanelState.LEFT]: PanelStateClass.LEFT,
            [PanelState.RIGHT]: PanelStateClass.RIGHT,
            [PanelState.DRAGGING]: PanelStateClass.DRAGGING,
          }
          this.$emit('moveClassChange', statusClass[this.panelStatus])
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onTouchStart(e) {
      let el = this.$refs.movable;
      let ctx = this;
      let windowWidth = window.innerWidth;
      let windowHeight = window.innerHeight;
      let elementRect = el.getBoundingClientRect();
      let elementHeight = elementRect.height;
      let elementWidth = elementRect.width
      let disX = e.touches[0].pageX - el.offsetLeft;
      let disY = e.touches[0].pageY - el.offsetTop;
      ctx.saveOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      el.ontouchend = function () {
        document.body.style.overflow = ctx.saveOverflow;
      };

      el.ontouchmove = function (ev) {
        ev.preventDefault();
        let pageX = ev.touches[0].pageX;
        let pageY = ev.touches[0].pageY;
        let left = pageX - disX
        let top = pageY - disY;
        if (top > ctx.boundary && top <= windowHeight - ctx.boundary - elementHeight) {
          el.style.top = top + 'px';
        }
        if (left <= 25) {
          el.style.left = '0';
          el.style.right = '';
          ctx.panelStatus = PanelState.LEFT
        } else if (left >= windowWidth - elementWidth - 25){
          el.style.right = '0';
          el.style.left = '';
          ctx.panelStatus = PanelState.RIGHT
        } else {
          el.style.left = left + 'px'
          el.style.right = '';
          ctx.panelStatus = PanelState.DRAGGING
        }
        el.ontouchend = function () {
          el.style.left = el.style.right = '';
          if (left < windowWidth / 2) {
            ctx.panelStatus = PanelState.LEFT
          } else {
            ctx.panelStatus = PanelState.RIGHT
          }
          el.ontouchmove = el.ontouchend = null;
          document.body.style.overflow = ctx.saveOverflow;
        };
      };
    },
  },
}
</script>

<style lang="less" src="./movable-panel.less" scoped></style>